module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-password-smart-edit"
  }, [_c('smart-edit', {
    attrs: {
      "options": _vm.options,
      "value": _vm.item
    },
    on: {
      "input": _vm.updateFields
    }
  }), _vm._m(0), _c('button', {
    staticClass: "button expanded",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v("Save and Submit")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "callout alert"
  }, [_c('h3', [_c('strong', [_vm._v("Warning")])]), _c('h5', [_vm._v("This may have legal implications")]), _c('p', [_vm._v("Inform the user to update his password as soon as possible")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9621de56!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/smartedits/DriverEditPassword.vue
// module id = 2626
// module chunks = 1